import { fromJS } from 'immutable'
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_RESET,
  LOGOUT_REQUEST,
  AUTH_OPEN_RESPONSE_MODAL,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
  responseModal: {
    isOpen: false,
    res: {},
  },
})

export default (state = init, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      if (action.payload !== undefined) {
        return state
          .set('isFetching', false)
          .set('isAuthenticated', false)
      }
      return state
        .set('isAuthenticated', false)
        .set('isFetching', true)
    case LOGIN_SUCCESS:
      return state
        .set('isAuthenticated', true)
        .set('auth', fromJS(action.payload.user))
        .set('status', 200)
        .set('message', 'Logged In Successfully.')
        .set('isFetching', false)
    case LOGIN_FAILURE:
      // if (action.payload.status === 401) {
      //   return state
      //     .set('redirect', true)
      //     .set('auth', fromJS(action.payload.message))
      //     .set('status', fromJS(action.payload.response.statusCode))
      //     .set('message', fromJS(action.payload.response.message))
      //     .set('isFetching', false)
      // }
      return state
        .set('auth', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case LOGIN_RESET:
      return state
        .delete('auth')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    case LOGOUT_REQUEST:
      return state
        .delete('auth')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    case AUTH_OPEN_RESPONSE_MODAL:
      return state
        .set('responseModal', action.payload.responseModal)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth/auth-reducer.js